import type { ReactNode, FC } from 'react';
import s from './FormSectionDescription.scss';

interface Props {
  children: ReactNode;
}

const FormSectionDescription: FC<Props> = ({ children }) => (
  <p className={s['root']}>{children}</p>
);

FormSectionDescription.displayName = 'FormSectionDescription';

export default FormSectionDescription;
